const routes = [
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('src/pages/Dashboard.vue') },
      { path: 'dashboard', component: () => import('src/pages/Dashboard.vue') },
      {
        path: 'servicestatus/:service_id',
        component: () => import('pages/ServiceStatus.vue'),
      },
      {
        path: 'profile',
        component: () => import('pages/user/Profile.vue'),
      },
      {
        path: 'cancellation',
        component: () => import('pages/user/Cancellation.vue'),
      },
      {
        path: 'notification',
        component: () => import('pages/user/Notification.vue'),
      },
    ],
  },
  {
    path: '/data',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('src/pages/Dashboard.vue') },
      {
        path: 'requestlist',
        component: () => import('pages/data/RequestList.vue'),
      },
      {
        path: 'search',
        component: () => import('pages/data/DataSearch.vue'),
      },
      // {
      //   path: 'upload',
      //   component: () => import('pages/data/UploadDB.vue'),
      // },
      {
        path: 'detail/:_id',
        component: () => import('pages/data/DetailDB.vue'),
      },
      {
        path: 'detail/:_id/:ref_page',
        component: () => import('pages/data/DetailDB.vue'),
      },
      {
        path: 'dblist',
        component: () => import('pages/data/DBList.vue'),
      },
      {
        path: 'batch_upload',
        component: () => import('pages/data/BatchUpload.vue'),
      },
    ],
  },
  {
    path: '/admin',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: 'dashboard',    component: () => import('src/pages/admin/AdminDashboard.vue') },
      { path: 'demo-data',    component: () => import('src/pages/admin/DemoDataManagement.vue') },
      { path: 'error_report', component: () => import('src/pages/admin/ErrorReport.vue') },
      { path: 'user_list',    component: () => import('src/pages/admin/UserList.vue') },
      { path: 'analysis_list', component: () => import('src/pages/admin/AnalysisList.vue') },
      { path: 'file_list',    component: () => import('src/pages/admin/FileList.vue') },
      { path: 'monitoring',   component: () => import('src/pages/admin/Monitoring.vue') },
      { path: 'server_monitoring', component: () => import('src/pages/admin/ServerMonitoring.vue') },
      { path: 'notification', component: () => import('src/pages/admin/NotificationManagement.vue') },
      { path: 'reset',       component: () => import('src/pages/admin/Reset.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      { path: '', component: () => import('pages/SignIn.vue') },
      { path: 'signin', component: () => import('pages/SignIn.vue') },
      { path: 'signup', component: () => import('pages/SignUp.vue') },
      { path: 'setup', component: () => import('pages/AdminSetup.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
